<template>
    <div class="page-section">
      <div class="breadcrumbs-custom box-transform-wrap context-dark">
        <div class="container">
          <h3 class="breadcrumbs-custom-title">O nama</h3>
          <div class="breadcrumbs-custom-decor"></div>
        </div>
        <vue-load-image>
          <div slot="image" alt="slight production o nama slika" class="box-transform" :data-src="require('./../images/aboutUs/bg-slight-production-onama.jpg')" :style="{ backgroundImage: 'url(' + require('./../images/aboutUs/bg-slight-production-onama.jpg') + ')' }"></div>
          <div slot="preloader" class="lds-roller">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>          
          <div slot="error">učitavam sliku...</div>
        </vue-load-image>        
      </div>           
      <section class="section about-us bg-gray-lighter section-md">
            <div class="shell-fluid shell-condensed">
                <div class="range range-condensed range-50 range-sm-0">
                  <div class="cell-sm-8 cell-lg-8 cell-xl-8 cell-sm-middle">
                      <div class="box-spacer">
                        <p class="heading-1">{{ title }}</p>
                        <article class="quote-big">
                            <div class="q" v-html="text"></div>
                        </article>
                        <div class="divider"></div>
                        <div v-html="description"></div>
                      </div>
                  </div>
                  <div class="cell-sm-4 cell-md-4 cell-xl-4 cell-image-wrap">
                      <img src="./../images/aboutUs/aboutUs.jpg" alt="" width="100%">
                  </div>
                </div>
            </div>
      </section>
    </div>
</template>

<script>
import axios from 'axios';

export default {
  metaInfo(){
    return{
      title: 'S light production - profesionalna tvrtka s višegodišnjim iskustvom',
      meta:[
        {
          name: 'description',
          content: 'S light production - koncerti, svečanosti, modne revije, plesna događanja, promocije, televizijska snimanja, sajmovi, izložbe, vjenčanja, privatne zabave - samo je dio naše ponude.'
        }
      ]
    }
  },
   data(){
      return{
          title:'',
          text:'',
          description:'',
          image:''
        }
   },   
   methods:{
      fetchData(){
        var url = this.apiPath + 'about_us/read.php';
        axios({
          method: 'get',
          url: url,
        })
        .then(function(response) {
          this.title = response.data.Title;
          this.text = response.data.Text;
          this.description = response.data.Description;
          this.image = response.data.Image;
        }.bind(this))
        .catch((error) => {
          console.log(error);
        });  
      }    
   },
   created(){
       this.fetchData();
   }   
}
</script>

<style lang="scss">
.about-us{   
    &.bg-gray-lighter {
        background-color: #f2f3f8;
    }

    .shell-fluid{
      max-width: 1200px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Onama.vue